import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep, pick } from 'lodash-es';
import { getStorageSalaryItem } from '@/api/payroll';
import { flattenTree, buildTree } from './tree';
import SortTree from './SortTree.vue';
function createPickerOptions() {
  return {
    disabledDate: function disabledDate(time) {
      return time.getTime() > Date.now();
    }
  };
}
export default {
  name: 'ExportExcelDialog',
  components: {
    SortTree: SortTree
  },
  props: {
    /**
     * 接口相关字段定义
     */
    props: {
      type: Object,
      default: function _default() {
        return {
          label: 'txt',
          children: 'columns',
          sort: 'sort',
          seleted: 'is_selected',
          type: 'relation_type'
        };
      }
    },
    needShowChecked: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      isCheckAll: false,
      showYear: false,
      year: '',
      filterText: '',
      selectTreeData: [],
      params: {},
      extraData: {},
      pickerOptions: createPickerOptions(),
      exportDisabled: false
    };
  },
  computed: {
    showDatePicker: function showDatePicker() {
      return +this.params[this.props.type] === 1;
    },
    defaultProps: function defaultProps() {
      return pick(this.props, ['label', 'children']);
    }
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.ElTree.filter(val);
    }
  },
  methods: {
    /**
     * 组件初始化入口函数
     * @param {*} params 列表查询参数
     * @param {*} extraData 导出excel接口的附加参数
     */
    init: function init(params, extraData) {
      var _this = this;
      if (!params) return;
      this.dialogVisible = true;
      this.loading = true;
      this.params = params;
      this.extraData = extraData;
      this.$http({
        url: '/web/payroll_setting/getExcelItems',
        method: 'GET',
        params: params
      }).then(function (res) {
        var data = [];
        var items = res.data.items;
        var keys = Object.keys(items);
        keys.forEach(function (key) {
          var item = items[key];
          var sort = item[_this.props.sort];
          data[sort] = _objectSpread({
            key: key
          }, item);
        });
        data = data.filter(function (item) {
          return item;
        });
        var count = 0;
        var vm = _this;
        function loop(source, pid) {
          source.forEach(function (item) {
            count++;
            item.id = count;
            item.pid = pid;
          });
          source.forEach(function (item) {
            if (item[vm.props.children]) {
              loop(item[vm.props.children], item.id);
            }
          });
        }
        loop(data, 0);
        _this.selectTreeData = data;
        var list = flattenTree(_this.props.children, cloneDeep(_this.selectTreeData));
        var defaultIds = list.filter(function (item) {
          return item[_this.props.seleted] === 1;
        }).map(function (item) {
          return item.id;
        });
        if (!_this.needShowChecked) {
          _this.$nextTick(function () {
            _this.$refs.ElTree.setCheckedKeys(defaultIds);
            _this.handleCheck();
          });
          return Promise.resolve();
        }
        var subProjectId = _this.extraData.sub_project_id || _this.params.relation_id;
        if (!subProjectId) {
          _this.$nextTick(function () {
            _this.$refs.ElTree.setCheckedKeys(defaultIds);
            _this.handleCheck();
          });
          return Promise.resolve();
        }
        return getStorageSalaryItem({
          sub_project_id: subProjectId
        }).then(function (storageRes) {
          var _storageRes$data;
          var checkedLeafKeys = (storageRes === null || storageRes === void 0 || (_storageRes$data = storageRes.data) === null || _storageRes$data === void 0 ? void 0 : _storageRes$data.item_keys) || [];
          var checkedLeafKeySet = new Set(checkedLeafKeys);
          var ids = (list || []).filter(function (item) {
            var children = item[_this.props.children];
            var isLeaf = !children || children.length === 0;
            return isLeaf && checkedLeafKeySet.has(item.column);
          }).map(function (item) {
            return item.id;
          });
          _this.$nextTick(function () {
            _this.$refs.ElTree.setCheckedKeys((ids || []).length ? ids : _this.selectTreeData.map(function (item) {
              return item.id;
            }));
            _this.handleCheck();
          });
        });
      }).catch(function () {
        _this.$nextTick(function () {
          var list = flattenTree(_this.props.children, cloneDeep(_this.selectTreeData));
          var ids = list.filter(function (item) {
            return item[_this.props.seleted] === 1;
          }).map(function (item) {
            return item.id;
          });
          _this.$refs.ElTree.setCheckedKeys(ids);
          _this.handleCheck();
        });
      }).finally(function () {
        _this.loading = false;
      });
    },
    /**
     * 导出接口相关参数处理
     */
    buildData: function buildData() {
      var sortTreeData = cloneDeep(this.$refs.SortTree.getData());
      var keys = sortTreeData.map(function (item) {
        return item.key;
      });
      var items = {};
      keys.forEach(function (key, index) {
        items[key] = sortTreeData[index];
      });
      var data = _objectSpread({
        items: items
      }, this.extraData);
      if (this.showDatePicker) {
        data.year = this.year;
      }
      return data;
    },
    handleFilterNode: function handleFilterNode(value, data) {
      if (!value) return true;
      return data[this.props.label].indexOf(value) !== -1;
    },
    handleAllowDrop: function handleAllowDrop(draggingNode, dropNode, type) {
      if (type === 'inner') {
        return false;
      }
      if (draggingNode.data.pid !== dropNode.data.pid) {
        return false;
      }
      return true;
    },
    /**
     * SortTree组件派发的放置事件
     */
    handleDrop: function handleDrop(parent) {
      var _this2 = this;
      var item = this.selectTreeData.find(function (item) {
        return item.id === parent.id;
      });
      if (item) {
        var children = item[this.props.children];
        children.forEach(function (left) {
          parent[_this2.props.children].forEach(function (right) {
            if (left.id === right.id) {
              left[_this2.props.sort] = right[_this2.props.sort];
            }
          });
        });
      }
    },
    /**
     * 全选事件
     */
    handleCheckAll: function handleCheckAll(v) {
      this.$refs.ElTree.setCheckedNodes(v ? this.selectTreeData : []);
      this.handleCheck();
    },
    /**
     * 单选事件
     */
    handleCheck: function handleCheck() {
      var _this3 = this;
      var list = flattenTree(this.props.children, cloneDeep(this.selectTreeData));
      var totalLength = list.length;
      var checkedNodes = this.$refs.ElTree.getCheckedNodes(false, true);
      var data = buildTree('id', 'pid', this.props.children, cloneDeep(checkedNodes));
      data.forEach(function (item) {
        var children = item[_this3.props.children];
        if (children) {
          // ascending order
          children = children.sort(function (a, b) {
            return a[_this3.props.sort] - b[_this3.props.sort];
          });
        }
      });
      this.$refs.SortTree.setData(data);
      this.isCheckAll = totalLength === checkedNodes.length;
      this.exportDisabled = checkedNodes.length === 0;
    },
    /**
     * SortTree组件派发的删除事件
     */
    handleDelete: function handleDelete(_ref, b) {
      var id = _ref.id;
      this.isCheckAll = false;
      this.exportDisabled = b;
      this.$refs.ElTree.setChecked(id, false, true);
    },
    /**
     * 导出事件
     */
    handleExport: function handleExport() {
      var _this4 = this;
      var data = this.buildData();
      if (this.showDatePicker && !this.year) {
        this.$message.warning(this.$t('i18n.de222615703a4c68a560a6348c3fe585'));
        return;
      }
      var urls = new Map([
      // 年度归档
      [1, '/web/payroll_staff/exportYearIncomeArchive'],
      // 员工薪资
      [2, '/web/payroll_staff/exportPayInfoData'],
      // 工资表
      [3, '/web/payroll_sub_project_staff/downloadPaySheet'],
      // 合并工资表
      [4, '/web/payroll_sub_project_staff/downloadPaySheetCombined']]);
      var type = +this.params[this.props.type];
      var url = urls.get(type);
      if (!url) return;
      this.loading = true;
      this.$http({
        url: url,
        data: data
      }).then(function () {
        _this4.$message.success(_this4.$t('payroll_salary_30'));
        _this4.dialogVisible = false;
      }).finally(function () {
        _this4.loading = false;
      });
    },
    /**
     * 重置组件相关数据
     */
    handleClosed: function handleClosed() {
      this.year = '';
      this.filterText = '';
      this.isCheckAll = false;
      this.selectTreeData = [];
      this.$refs.SortTree.setData([]);
    }
  }
};